module.exports = __webpack_public_path__ + "img/home.f8b843e6.svg";